import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="الرئيسية" className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20 bg-black">
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="absolute inset-0 h-full w-full object-cover opacity-45"
      >
        <source src="/lodng-web.mp4" type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(17,184,173,0.20),rgba(0,0,0,0.45)_35%,rgba(0,0,0,0.92)_78%)]" />
      
      {/* 3D Perspective Grid */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" style={{ perspective: '1000px' }}>
        <div className="absolute bottom-[-30%] left-[-50%] w-[200%] h-[120%] bg-[linear-gradient(to_right,rgba(0,243,255,0.15)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,243,255,0.15)_1px,transparent_1px)] bg-[size:50px_50px] animate-[grid-move_2s_linear_infinite]" style={{ transform: 'rotateX(75deg)' }} />
      </div>

      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#050505] to-transparent" />

      <div className="container mx-auto px-6 text-center z-10">
        <motion.img
          src="/server-logo.gif"
          alt="مقاطعة الراية"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="mx-auto mb-8 h-32 w-32 md:h-44 md:w-44 rounded-full object-cover shadow-neon"
        />

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        className="text-5xl md:text-8xl font-black mb-6 text-white leading-tight"
        >
        مرحباً بك في <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">مقاطعة الراية</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-gray-300 text-lg md:text-2xl mb-10 max-w-3xl mx-auto"
        >
          سيرفر حياة واقعية بتفاصيل عالية، قطاعات نشطة، وأنظمة مصممة لتجربة لعب منظمة وممتعة.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-5"
        >
          <a href="https://discord.gg/x5" target="_blank" rel="noreferrer" className="px-10 py-4 w-full sm:w-auto bg-neon-cyan text-black rounded-full font-bold shadow-neon hover:bg-white transition-all duration-300 inline-block">
            انضم للديسكورد الآن
          </a>
          <Link to="/about" className="px-10 py-4 w-full sm:w-auto bg-black/35 border border-neon-cyan/50 text-white rounded-full font-bold hover:border-neon-cyan hover:text-neon-cyan hover:shadow-neon transition-all duration-300 backdrop-blur-md">
            تصفح الموقع
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
